import React from "react";
import CommonDataTable from "../../../components/Datatable/CommonDataTable";
import Format from "../../../helpers/Format";
import PropTypes from "prop-types";
import { meses } from "../../../helpers/mesesHelper";

function FaturamentoDataTable({
  linhas,
  linhaFooter,
  togFaturamento,
  ano,
  meiMe,
}) {
  const colunas = React.useMemo(
    () => [
      {
        Header: "Ano",
        accessor: () => {
          return ano;
        },
        disableSortBy: true,
      },
      {
        Header: "Mês",
        accessor: (row) => {
          return meses[row.mes];
        },
        disableSortBy: true,
      },
      {
        Header: "Receita nacional",
        accessor: (row) => {
          return Format.formataValor(
            row.receita_nacional + row.receita_nacional_adicional || 0
          );
        },
        disableSortBy: true,
      },
      {
        Header: "Receita internacional",
        accessor: (row) => {
          return Format.formataValor(
            row.receita_internacional + row.receita_internacional_adicional || 0
          );
        },
        disableSortBy: true,
      },
      {
        Header: "Valor total",
        accessor: (row) => {
          return Format.formataValor(row.valor_total);
        },
        disableSortBy: true,
      },
      {
        Header: "Ações",
        disableSortBy: true,
        Cell: ({ row }) => {
          let anoMei;
          let mesMei;
          let anoFiltro = parseInt(ano);
          let mesLinha = parseInt(row.original.mes);
          if (meiMe) {
            anoMei = parseInt(meiMe.split("-")[0]);
            mesMei = parseInt(meiMe.split("-")[1]);
          }

          return (anoMei === anoFiltro && mesMei <= mesLinha) ||
            anoFiltro !== anoMei ? (
            <button
              onClick={() => {
                togFaturamento({ ...row.original, ano: ano });
              }}
              style={{ border: "0px", backgroundColor: "transparent" }}
            >
              <i className="mdi mdi-cash-check d-block font-size-20 text-success"></i>
            </button>
          ) : (
            <div style={{ height: "30px" }}></div>
          );
        },
      },
    ],
    [ano, meiMe, togFaturamento]
  );

  const footer = React.useMemo(
    () => [
      {
        Header: "Ano",
        Cell: () => {},
      },
      {
        Header: "Mês",
        accessor: (row) => {
          return (
            <span style={{ color: "rgb(73, 80, 87)", fontWeight: 600 }}>
              {row.mes}
            </span>
          );
        },
      },
      {
        Header: "Receita nacional",
        accessor: (row) => {
          return (
            <span style={{ color: "rgb(73, 80, 87)", fontWeight: 600 }}>
              {Format.formataValor(
                row.receita_nacional + row.receita_nacional_adicional || 0
              )}
            </span>
          );
        },
      },
      {
        Header: "Receita internacional",
        accessor: (row) => {
          return (
            <span style={{ color: "rgb(73, 80, 87)", fontWeight: 600 }}>
              {Format.formataValor(
                row.receita_internacional +
                  row.receita_internacional_adicional || 0
              )}
            </span>
          );
        },
      },
      {
        Header: "Valor total",
        accessor: (row) => {
          return (
            <span style={{ color: "rgb(73, 80, 87)", fontWeight: 600 }}>
              {Format.formataValor(row.valor_total)}
            </span>
          );
        },
      },
      {
        Header: "Ações",
        disableSortBy: true,
        Cell: () => {},
      },
    ],
    []
  );

  return (
    <CommonDataTable
      colunas={colunas}
      linhas={linhas}
      footer={footer}
      linhaFooter={linhaFooter}
      customPageSize={12}
    />
  );
}

FaturamentoDataTable.propTypes = {
  linhas: PropTypes.array.isRequired,
  linhaFooter: PropTypes.array.isRequired,
  togFaturamento: PropTypes.func.isRequired,
  ano: PropTypes.number.isRequired,
  meiMe: PropTypes.string.isRequired,
  row: PropTypes.object,
};

export default FaturamentoDataTable;
